import React from 'react';
import styles from './CommentList.module.css';

interface Comment {
    id: number;
    author: string;
    text: string;
    date: string;
    time: string;
}

interface CommentListProps {
    comments: Comment[];
    isHoliday?: boolean;
}

const CommentList: React.FC<CommentListProps> = ({ comments, isHoliday = false }) => {
    if (comments.length === 0) {
        return (
            <div className={`${styles.noComments} ${isHoliday ? styles.holiday : ''}`}>
                <div>Пока нет комментариев.</div>
                <p>Не стесняйтесь, ваш комментарий может быть первым!</p>
                <p>Мы не кусаемся... обычно 😉</p>
            </div>
        );
    }

    return (
        <div className={styles.commentList}>
            {comments.map((comment, index) => (
                <div
                    key={comment.id}
                    className={`${styles.comment} ${isHoliday ? styles.holiday : ''}`}
                    style={{ animationDelay: `${index * 0.1}s` }}
                >
                    <div className={styles.commentHeader}>
                        <strong className={styles.name}>{comment.author}</strong>
                        <div className={styles.dateTime}>
                            <span>{comment.date}</span>
                            <span>{comment.time}</span>
                        </div>
                    </div>
                    <p className={styles.text}>{comment.text}</p>
                </div>
            ))}
        </div>
    );
};

export default CommentList;